export enum TenantColumn {
  TYPE = 'type',
  REGION = 'region',
  CLOUD = 'cloud',
  STATUS = 'status'
}

export const tenantColumns = Object.values(TenantColumn) as string[];
